import { isFunction } from "lodash";
import React, { memo, useCallback } from "react";
import { useSelector } from "react-redux";
import { useUnderwritingHook } from "../../../../hooks/useUnderwritingHook";
import { Chip, CircularProgress, Tooltip } from "@mui/material";
import { CloseRounded, LocalOfferOutlined } from "@mui/icons-material";
import { green, grey } from "@mui/material/colors";

const ExistingLoanTag = memo(({ children, onDeleteSuccess, allowDelete }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const { removeLoanTag, loading } = useUnderwritingHook();

  const onTagDelete = useCallback(async () => {
    // return;
    removeLoanTag({
      dealId: loanDrilldown?._id,
      tag: children,
      onSuccessFn: (data) => {
        if (isFunction(onDeleteSuccess)) {
          onDeleteSuccess(data);
          // handleOnClose();
        }
      },
    });
  }, [loanDrilldown?._id, children]);

  return (
    <Chip
      icon={<LocalOfferOutlined sx={{ fontSize: "13px" }} />}
      deleteIcon={
        loading ? (
          <CircularProgress
            size={12}
            sx={{ ml: "6px !important", fontSize: "15px !important" }}
          />
        ) : (
          <Tooltip title="Remove Tag">
            <CloseRounded
              sx={{
                ml: "6px !important",
                fontSize: "15px !important",
                color: `${grey[900]} !important`,
              }}
              className="thin"
            />
          </Tooltip>
        )
      }
      label={children}
      onDelete={allowDelete ? onTagDelete : null}
      sx={{
        height: "24px",
        px: 0.5,
        background: green[50],
      }}
    />
  );
});

export default ExistingLoanTag;
